export default "__VITE_ASSET__7B8fGSVq__"